import { AxiosError } from "axios";
import { QueryKey, useQuery, UseQueryOptions } from "react-query";
import PartnersShowcaseService, {
  Categories,
} from "#/api/partnersShowcase/partnersShowcase";
import { errorTransform } from "#/infrastructure/error-handler";

type GetCategoriesProps = {
  options?: UseQueryOptions<Categories[], AxiosError, Categories[]>;
};

export const useGetCategories = ({ options = {} }: GetCategoriesProps) => {
  return useQuery(
    ["categories"] as QueryKey,
    () => PartnersShowcaseService.getCategories(),
    {
      ...options,
      enabled: true,

      onError: (responseError: AxiosError) => {
        throw errorTransform(
          responseError,
          "Falha ao buscar categorias. Tente novamente."
        );
      },
    }
  );
};
